'use client';

import { clsx } from 'clsx';
import { FC } from 'react';
import { StoryBlokLink } from 'atoms/StoryBlokLink';
import {
  gtmPushBurgerMenuMobileSecondLevel,
  gtmPushBurgerMenuMobileThirdLevel,
} from 'modules/gtm/modules/sections/navigation/navigation';
import { useTranslations } from 'modules/i18n/useTranslations';
import { SidebarAccordion } from '../SideBarAccordion';
import { flattenFlyout } from './helpers';
import type { INavigationItemSecondLevelProps } from './types';
import styles from './styles.module.css';

export const NavigationItemSecondLevel: FC<INavigationItemSecondLevelProps> = ({
  firstLevelItem,
  secondLevelItem,
  expandedAccordion,
  handleAccordionChange,
}) => {
  const t = useTranslations();

  const handleSecondLevelClick = (
    itemParentTitle: string,
    columnItem: string,
  ) => {
    gtmPushBurgerMenuMobileSecondLevel(itemParentTitle, columnItem);
  };

  const handleThirdLevelClick = (
    itemParentTitle: string,
    columnItem: string,
    linkTitle: string,
  ) => {
    gtmPushBurgerMenuMobileThirdLevel(itemParentTitle, columnItem, linkTitle);
  };

  if (
    secondLevelItem.flyoutColumns?.length === 0 &&
    secondLevelItem.children?.length === 0
  ) {
    return secondLevelItem.url ? (
      <StoryBlokLink
        className={clsx(styles.link, styles.linkBox)}
        key={secondLevelItem._uid}
        link={secondLevelItem.url}
        onClick={() =>
          handleSecondLevelClick(firstLevelItem.title, secondLevelItem.title)
        }
      >
        {secondLevelItem.title}
      </StoryBlokLink>
    ) : null;
  }
  const childrenSecondLevel = secondLevelItem?.children ?? [];
  const navigationThirdLevelItems = [
    ...childrenSecondLevel,
    ...flattenFlyout(secondLevelItem),
  ];

  return (
    <>
      <SidebarAccordion
        key={secondLevelItem._uid}
        summaryContent={secondLevelItem.title}
        summaryInlineStyle={{
          backgroundColor:
            expandedAccordion === secondLevelItem._uid &&
            secondLevelItem.color.color,
        }}
        expanded={expandedAccordion === secondLevelItem._uid}
        onChange={() => handleAccordionChange(secondLevelItem._uid)}
        onClick={() =>
          handleSecondLevelClick(firstLevelItem.title, secondLevelItem.title)
        }
      >
        {secondLevelItem.url && (
          <StoryBlokLink
            className={clsx(styles.link, styles.linkTextThirdLevel)}
            link={secondLevelItem.url}
          >
            {t('header.navigation.all', {
              categoryName: secondLevelItem.title,
            })}{' '}
          </StoryBlokLink>
        )}
        {navigationThirdLevelItems.map((thirdLevelItem) =>
          thirdLevelItem?.url ? (
            <StoryBlokLink
              className={clsx(styles.link, styles.linkTextThirdLevel)}
              key={thirdLevelItem._uid}
              link={thirdLevelItem.url}
              onClick={(e) => {
                e.stopPropagation();
                handleThirdLevelClick(
                  firstLevelItem.title,
                  secondLevelItem.title,
                  thirdLevelItem?.title || '',
                );
              }}
            >
              {thirdLevelItem?.title}
            </StoryBlokLink>
          ) : null,
        )}
      </SidebarAccordion>
    </>
  );
};
